import React, { useState } from "react";
import Button from "../../../components/buttons/Button";
import Dialog from "../../../components/dialog/Dialog";
import Content from "../../../components/Content";
import { useNavigate } from "react-router-dom";
import { ServiceTable } from "../../../components/service/ServiceTable";
import { CreateServiceModal } from "../../../modals/service/CreateServiceModal";
import SearchInput from "../../../components/Inputs/SearchInput";
import { Typography, Box, Card, CardContent } from "@mui/material";

export const ServiceView = () => {
  const navigate = useNavigate();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const clickRow = (id) => {
    // id is already transformed from the backend
    navigate(`./overview/${id}`);
  };

  return (
    <>
      <Content title={"Tjänster"}>
        <Box sx={{ p: 3 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Tjänster
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <SearchInput />
                  <Button onClick={() => setIsCreateModalOpen(true)}>
                    Skapa Ny Tjänst
                  </Button>
                </Box>
              </Box>
              <Typography variant="body1" color="text.secondary">
                Hantera tjänster för din organisation. Skapa och organisera olika tjänster som kan tilldelas till tjänstegrupper och spåras i systemet.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <ServiceTable handleSelect={(item) => clickRow(item.id)} />
            </CardContent>
          </Card>
        </Box>
          <Dialog
            open={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            title="Skapa Tjänst"
          >
            <CreateServiceModal
              closeCreateModal={() => setIsCreateModalOpen(false)}
            />
          </Dialog>
      </Content>
    </>
  );
};
